//@ts-check
import ContactUtils from '../../../utils/contact';
var isLead = ContactUtils.isLead,
    getDisplayName = ContactUtils.getDisplayName;
/**@type {import('../types').DataType<import('./contact').ContactModel>} */

var CONTACT_DATA_TYPE = {
  data: {
    url: '/backend/contacts',
    itemUrl: '/backend/contacts?synchronizationId={id}',
    dataKey: 'contactsCRM',
    idKeyProp: 'SynchronizationId'
  },
  placeholders: {
    type: function type(data) {
      return isLead(data) ? 'lead' : 'contact';
    },
    label: function label(data) {
      var name = getDisplayName(data);
      return name ? name : '(No name)';
    },
    icon: function icon(data) {
      return isLead(data) ? 'lead' : 'contact';
    }
  }
};
export default CONTACT_DATA_TYPE;